import styled from 'styled-components';
import FormControlLabel from '@mui/material/FormControlLabel';
import { theme } from '@silverrailtech/srtlibrary';

export const FormContent = styled.div`
	.MuiFormControl-root.MuiTextField-root {
		margin-top: 0 !important;
	}

	a {
		color: ${theme.colors.text.interaction.textLink};
		text-decoration: underline;
	}
`;

export const CheckboxLabel = styled(FormControlLabel)`
	&& {
		align-items: center;

		.MuiFormControlLabel-label {
			font-size: 12px;
		}

		.MuiCheckbox-root {
			padding: 3px 9px;
		}

		.MuiCheckbox-root.Mui-checked {
			color: ${theme.colors.interaction.fill.primary1};
		}
	}
`;
